<template>
  <div>
    <div class="content-area__heading pr-4 border-0">
      <h3 style="margin-bottom: 20px">Carrito</h3>
    </div>
    <vs-row>
      <vs-col vs-w="9" vs-xs="12" class="lista-carrito">
        <div v-for="(reserva_nodo,index) in carrito" :key="index">
          <div v-if="reserva_nodo.cantidad > 0 && reserva_nodo.reserva.estado == -1">
            <vs-card style="margin: 0px">
              <vs-row>
                <vs-col vs-w="9" vs-xs="12" style="padding: 10px;">
                  
                  <ruta class="rutas" :nodos="nodos" :nodo_id="reserva_nodo.nodo.id" @ir_al_padre="ir_al_nodo" style="font-size: 17px;"></ruta>

                  <h4 class="item-name font-semibold mb-1 cursor-pointer hover:text-primary" style="margin-top: 20px" @click="$router.push({ path: `/home/${reserva_nodo.nodo.id}` })">{{reserva_nodo.nodo.titulo}}</h4>

                  <div v-for="(extra,extra_index) in reserva_nodo.extras" :key="extra_index">
                    <p class="text-sm mb-2" >
                      {{extra.extra.concepto}}
                    </p>
                    <vs-input-number 
                      style="max-width: 86px;" 
                      min="0" 
                      :max="(extra.extra.permitecantidad == 0)?1:999999999" 
                      :value="reserva_nodo.extras[extra_index].cantidad"
                      @input="extra_cantidad(index,extra_index,$event)"
                      />
                  </div>
                </vs-col>
                <vs-col vs-w="3" vs-xs="12" class="item-resumen">
                  <p>Total</p>
                  <h3 data-v-3e4a5c2c="" class="font-bold text-center" style="margin-bottom: 20px; text-align: center">
                    {{reserva_nodo.precio_nodo + reserva_nodo.precio_extras}} €
                  </h3>

                  <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-x" @click="cantidad(index,0)" style="margin: auto;">
                    Eliminar
                  </vs-button>

                </vs-col>
              </vs-row>
            </vs-card>
          </div>
        </div>
      </vs-col>
      <vs-col vs-w="3" vs-xs="12" class="carrito_resumen">
        <vs-card style="padding: 10px">
          <div class="detalles">Listado de items</div>
          <div v-for="(reserva_nodo,index) in carrito" :key="index">
            <div class="flex justify-between mb-2 conceptos" v-if="reserva_nodo.cantidad > 0 && reserva_nodo.reserva.estado == -1">
              <span class="text-grey">{{reserva_nodo.nodo.titulo}}</span>
              <span>{{reserva_nodo.precio_nodo + reserva_nodo.precio_extras}} €</span>
            </div>
          </div>
          <vs-divider></vs-divider>
          <div class="flex justify-between mb-2 total">
            <span class="">Total</span>
            <span>{{total}} €</span>
          </div>
          <vs-button 
            style="margin-bottom: 35px;width: 100%"
            class="btn-contratar"
            color="success" 
            :disabled="!(total > 0)"
            @click="contratar()"
            >
            Pagar
          </vs-button>
        </vs-card>
      </vs-col>
    </vs-row>
      
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import axios from 'axios'
import ruta from '@/components/Ruta.vue'

export default {
  data() {
    return {
      nodos: [],
      activeLoading:false,
    }
  },
  created(){
    //Nodos
    this.$store.dispatch('get_nodos').then((data) => {
      if(typeof data !== 'undefined')
        this.nodos = data
    })
  },
  computed: {
    ...mapGetters(["carrito"]),
    carrito_actual(){
      var carrito_actual = []
      this.carrito.forEach((reserva_nodo,index) => {

        if(reserva_nodo.cantidad > 0 && reserva_nodo.reserva.estado == -1){
          reserva_nodo.index = index
          carrito_actual.push(reserva_nodo)
        }
      })
      return carrito_actual
    },
    total() {
      var total = 0;
      this.carrito.forEach(reserva_nodo => {

        if(reserva_nodo.cantidad > 0 && reserva_nodo.reserva.estado == -1){
          total += reserva_nodo.precio_nodo + reserva_nodo.precio_extras
        }
      })
      return total
    }
  },
  mounted(){
  },
  methods: {
    ir_al_nodo(nodo_id){
      this.$router.push({ path: `/home/${nodo_id}` })
    },
    get_hijos(){
      this.$store.dispatch('get_hijos').then((data) => {
        if(typeof data !== 'undefined')
          this.hijos_del_padre = data
      })
    },
    contratar(){ 
      
      axios.defaults.baseURL = process.env.VUE_APP_API_URL
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.getters['auth/token']

      this.activeLoading = true
      this.$vs.loading({
        type:'default',
      })
      axios.post('/reserva',{
        carrito: this.carrito
      })
      .then(response => {
        if(response.data.success){
          this.$vs.notify({
            title:'Éxito',
            text: 'Redirigiendo...',
            color:'success'
          })
          this.get_hijos()
          if(response.data.urlPago !== 'paygold'){
            if(response.data.urlPago !== ''){
              window.location = response.data.urlPago;
              this.$store.commit('guardar_carrito',[])
              this.$router.push('/reservas/')
              
              this.activeLoading = false
              this.$vs.loading.close()
            }else{
              this.$store.commit('guardar_carrito',[])
              this.$router.push('/reservas/')
              
              this.activeLoading = false
              this.$vs.loading.close()
            }
          }else{
            this.$store.commit('guardar_carrito',[])
            this.$router.push('/paygold-espera/')
            
            this.activeLoading = false
            this.$vs.loading.close()
          }  
          
         
        }else{
          this.activeLoading = false
          this.$vs.loading.close()
          this.$vs.notify({
            title:'Error',
            text:response.data.message,
            color:'danger',
            time:6000,
          })
        }
      })
    },
    cantidad(index,cantidad){
      this.$store.commit('cantidad', {
        cantidad: cantidad,
        index: index
      })
    },
    extra_cantidad(index, extra_index, cantidad){
      this.$store.commit('extra_cantidad', {
        index: index,
        extra_index: extra_index,
        cantidad: cantidad
      })
    },
  },
  components: {
    ruta
  }
}
</script>

<style lang="scss" scoped>
.lista-carrito{
  padding-right: 15px;
  .item-resumen{
    padding-top: 40px; 
    text-align: center;
    >p{
      font-size: 16px;
      color: #b1b1b1;
    }
    >h5{
    }
  }
}
.carrito_resumen{
  .detalles{
    font-size: 16px;
  }
  .conceptos{
    font-size: 16px;
  }
  .total{
    font-size: 18px;
  }
}
</style>
